import { Alert, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { defaultGridContainerProps, defaultGridItemProps } from 'util/Layout';
import UseRequestData from 'store/types/UseRequestData';
import Badge from 'store/types/Badge';
import PageCard from 'components/shared/PageCard';
import Spinner from 'components/shared/Spinner';

import styles from './HomeBadgesSection.module.scss';

function groupBy<T, K extends string | number | symbol>(
  list: T[] | null | undefined,
  keyGetter: (item: T) => K
): Map<K, T[]> {
  const map = new Map<K, T[]>();
  if (!list) return map;

  for (const item of list) {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  }

  return map;
}

interface HomeBadgesSectionProps {
  request: UseRequestData<Badge[]>;
  fullWidth?: boolean;
}

const HomeBadgesSection: React.FunctionComponent<HomeBadgesSectionProps> = ({ request, fullWidth }) => {
  const { data, loading, error } = request;
  const badgeCategoryGroups: [string, Badge[]][] = useMemo(() => {
    return data ? Array.from(groupBy(data, ({ category }) => category ?? 'Badges')) : [];
  }, [data]);

  return (
    <Spinner loading={loading} transparent={false}>
      {error ? (
        <Alert severity={'error'}>{error}</Alert>
      ) : (
        <Grid {...defaultGridContainerProps}>
          {badgeCategoryGroups &&
            badgeCategoryGroups.length > 0 &&
            badgeCategoryGroups.map(([category, badges]) => (
              <Grid {...defaultGridItemProps} key={`badge-category-${category}`} lg={fullWidth ? 12 : 6}>
                <PageCard title={category}>
                  <div className={styles.badgeContainer}>
                    {badges.map((badge) => (
                      <img key={badge.id} className={styles.badgeLogo} src={badge.logoUrl} alt={'logo'} />
                    ))}
                  </div>
                </PageCard>
              </Grid>
            ))}
        </Grid>
      )}
    </Spinner>
  );
};
export default HomeBadgesSection;
